import { AuthService } from 'src/app/core/service/auth.service';

import { Component, Inject, ElementRef, OnInit, Renderer2, AfterViewInit, ViewChild, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/config/config.service';
import { InConfiguration } from 'src/app/core/models/config.interface';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { localStorageConstants } from 'src/consts/local-storage-constants';

import { configData } from 'src/environments/configData';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Direction } from '@angular/cdk/bidi';
import { SwitchCompanyComponent } from './switch-company/switch-company.component';
import { SUPERADMIN_ROUTES, WEB_ROUTES } from 'src/consts/routes';
import { CommonService } from 'src/app/services/common.service';
import { httpRoutes, httpVersion, superAdminRoutes } from 'src/consts/http-routes';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Invoice } from 'src/app/invoice/invoice.model';
import { notificationRoutes, numberWithCommas, showNotification } from 'src/consts/utils';
import { UiSpinnerService } from 'src/app/services/ui-spinner.service';
import { AuthenticationService } from '../../authentication/authentication.service';
import { RolePermission } from 'src/consts/common.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorDialogComponent } from 'src/app/superadmin/authentication/company-registration-form/company-registration-form.component';
import { HttpCall } from 'src/app/services/httpcall.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SocketService } from 'src/app/socket.service';
import { ManageSubscriptionPopUpComponent } from 'src/app/superadmin/authentication/manage-subscription-pop-up/manage-subscription-pop-up.component';
import { CommonModule, NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FeatherIconsModule } from 'src/app/shared/components/feather-icons/feather-icons.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonComponentsModule } from 'src/app/common-components/common-components.module';
import { MatIconModule } from '@angular/material/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatBadgeModule } from '@angular/material/badge';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LanguageComponent } from '../language/language.component';
import { LoadingComponent } from 'src/app/common-components/loading/loading.component';

interface Notifications {
  _id: string;
  notification_title: string;
  notification_description: string;
  module_name: string;
  module_route: any;
  is_complete: boolean;
  is_seen: boolean;
  created_at: number;
  tab_index: number;
}

const moduleDisplayNames: { [key: string]: string } = {
  cost_code: "Cost Code",
  terms: "Terms",
  class: "Class",
  client: "Client",
  vendor: "Vendor",
  invoice: "Invoice",
};

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    NgClass,
    MatButtonModule,
    MatMenuModule,
    NgScrollbarModule,
    FeatherIconsModule,
    MatSlideToggleModule,
    FormsModule,
    TranslateModule,
    MatTooltipModule,
    CommonComponentsModule,
    MatIconModule,
    CommonModule,
    InfiniteScrollModule,
    MatBadgeModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    LoadingComponent,
    LanguageComponent
  ]
})
export class HeaderComponent extends UnsubscribeOnDestroyAdapter implements OnInit, AfterViewInit {
  @ViewChild("menuTrigger") trigger: MatMenuTrigger | any;

  public config!: InConfiguration;
  isNavbarCollapsed = true;
  isOpenSidebar?: boolean;
  docElement: HTMLElement | undefined;
  isFullScreen = false;
  isDarTheme = false;
  toggleControl = new FormControl(false);
  darkIcon?: string;
  userName?: string;
  userPicture?: string;
  unseenCount = 0;
  companyCode = '';
  companyName = '';
  company_logo: any = "../assets/images/placeholder_logo.png";


  companyList: any = [];
  isLoading = true;
  public role_permission!: RolePermission;

  paymentData: any
  end_date: any
  role_name: any
  currentEpochTime!: number; // Current time in seconds since epoch
  is_show: boolean = false
  isDialogShown: boolean = false;
  isTrialAlertVisible = false;
  companyData: any;
  user_data: any;

  progressValue: number = 0;
  currentModule: string = '';
  showProgress = false; // Control progress bar visibility
  onlineLoggedIn!: boolean;
  company_currency: any;
  is_quickbooks_sync: any
  quickbook_conpany_name: any
  company_name = '';
  is_admin = false;
  constructor(@Inject(DOCUMENT) private document: Document, private renderer: Renderer2, public elementRef: ElementRef,
    public uiSpinner: UiSpinnerService, private configService: ConfigService, private authService: AuthService,
    private authenticationService: AuthenticationService, private snackBar: MatSnackBar, private socketService: SocketService,
    private router: Router, public translate: TranslateService, public dialog: MatDialog, private commonService: CommonService,) {
    super();
    this.role_permission = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA)!)?.role_permission;
    this.user_data = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA)!);
    if (this.user_data?.companydata) {
      this.is_quickbooks_sync = this.user_data.UserData.is_quickbooks_sync;
      this.companyData = this.user_data.companydata;
      this.isTrialAlertVisible = this.user_data.companydata.is_trial;
    }
    let user_role = this.user_data.UserData.role_name;
    if (user_role === 'Admin') {
      this.is_admin = true;
    } else {
      this.is_admin = false;
    }
    this.getCompanyAndUserPicture();
  }
  notificationList: Notifications[] = [];
  notificationCount = 0;
  notificationLoading = true;
  start = 0;
  searchControl = new UntypedFormControl();
  invoiceList: Array<Invoice> = [];
  invoiceLoader = true;
  openSearchDialog = false;
  image_url: any;

  async ngOnInit() {
    this.socketService.pendingInvoiceCount.subscribe((data) => {
      this.getNotification();
    })
    this.getPaymentDetails()
    if (this.is_show && !this.isDialogShown) {
      this.showErrorDialog();
      this.isDialogShown = true; // Ensure the dialog is shown only once
    }
    this.getGIF();
    this.config = this.configService.configData;
    const user_data = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA)!);

    const requestObject = {
      useremail: user_data.UserData.useremail
    };
    const encryptedData = this.authenticationService.encription(requestObject);
    const hex = this.authenticationService.getHex();

    const data = await this.commonService.postRequestAPI(httpVersion.V1 + httpRoutes.GET_MY_COMPANY_LIST, { encryptedData, iv: hex }
    );
    this.isLoading = false;
    if (data.status) {
      this.companyList = data.data;
    }

    let tmp_locallanguage = localStorage.getItem(localStorageConstants.LANGUAGE);
    tmp_locallanguage = tmp_locallanguage == '' || tmp_locallanguage == undefined || tmp_locallanguage == null ? configData.INITIALLANGUAGE : tmp_locallanguage;
    this.translate.use(tmp_locallanguage);
    this.getNotification();
    this.getInvoiceMessageCount();
    this.getCompanyTenants();
  }

  async getGIF() {
    let that = this;
    const data = await this.commonService.getRequestAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.GET_GIF);
    if (data.status) {
      if (data.data != null) {
        that.image_url = data.data.image_url;
        localStorage.setItem("smartaccupay-logo", data.data.image_url);
        localStorage.setItem("smartaccupay-gif", data.data.gif_url);
      }
    }
  }

  async getCompanyAndUserPicture() {
    const data = await this.commonService.getRequestAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.GET_COMPANY_AND_USER_PROFILE);
    if (data.status) {
      this.companyName = data.data.company.companyname;
      this.companyCode = data.data.company.companycode;
      this.company_logo = data.data.company.companylogo;
      this.userName = data.data.user.userfullname;
      this.userPicture = data.data.user.userpicture;
    }
  }

  async getNotification() {
    const data = await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.GET_ALL_ALERTS, { start: this.start });
    this.notificationLoading = false;
    if (data.status) {
      if (this.start == 0) {
        this.notificationList = data.data;
      } else {
        this.notificationList = this.notificationList.concat(data.data);
      }
      this.notificationCount = data.unseen_count;
    }
  }

  setHeightStyles() {
    const styles = {
      height: '350px',
      "overflow-y": "scroll",
    };
    return styles;
  }

  onScroll() {
    this.start++;
    this.getNotification();
  }

  async getPaymentDetails() {
    this.is_show = false; // Initially, hide the alert
    const userdata = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA) ?? '{}');

    const data = await this.commonService.postRequestAPI(
      httpVersion.PORTAL_V1 + httpRoutes.GET_COMPANY_FOR_PAYMENT_DETAILS,
      { _id: userdata.companydata._id }
    );

    if (data.status) {
      this.paymentData = data.data[0];
      this.end_date = this.paymentData.current_period_end; // Epoch timestamp of plan end date
      this.role_name = userdata.UserData.role_name; // User role
      this.currentEpochTime = Math.floor(Date.now() / 1000); // Current time in seconds

      // Condition: Show the alert only if end_date is expired and role_name is not 'Employee'
      if (this.end_date <= this.currentEpochTime) {
        this.is_show = true; // Show the alert
        if (this.is_show && !this.isDialogShown) {
          this.showErrorDialog();
          this.isDialogShown = true; // Ensure the dialog is shown only once
        }
      } else {
        this.is_show = false; // Hide the alert
      }
    }
  }
  ticketSystem() {
    this.router.navigate(['ticket-list']);
  }

  goHelpMenu() {
    this.router.navigate(['help-menu']);
  }


  showErrorDialog(): void {
    let tenDaysInSeconds
    if (this.paymentData.plan_details.duration == 'month') {
      tenDaysInSeconds = 864000
    } else {
      tenDaysInSeconds = 1296000
    }
    // Add 10 days in seconds

    const futureEpochTime = this.end_date + tenDaysInSeconds; // Future time in seconds

    // Convert to a readable date
    const futureDate = new Date(futureEpochTime * 1000); // Convert epoch time to milliseconds
    const formattedFutureDate = `${(futureDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${futureDate
        .getDate()
        .toString()
        .padStart(2, '0')}/${futureDate.getFullYear()}`;


    // Use the formatted date in your dialog
    const message = `Your account is going to be suspended on date ${formattedFutureDate}. Please submit payment.`;

    this.dialog.open(ErrorDialogComponent, {
      data: { message }, // Pass the message to the dialog component
      width: '400px',
      panelClass: 'rounded-dialog'
    });
  }
  async redirectToPayment() {
    const userdata = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA) ?? '{}');
    let paymentData

    paymentData = this.paymentData.plan_details;
    let plan, price


    this.router.navigate([SUPERADMIN_ROUTES.UPDATE_PAYMENT_RESTRICTION_SCREEN], {
      queryParams: {
        companyId: userdata.companydata._id,
        companyCode: userdata.companydata.companycode,
        companyName: userdata.companydata.companyname,
        companyEmail: userdata.companydata.companyemail,
        plan: paymentData.name,
        price: paymentData.price,
        is_trial_end: paymentData.is_trial_end,
        is_free_trial_upgrade: false,
        plan_id: paymentData._id,
      }
    });
  }


  async openNotificationPage(notification: Notifications) {
    this.uiSpinner.spin$.next(true);
    if (!notification.is_seen) {
      await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.UPDATE_ALERT, { _id: notification._id, is_seen: true });
      const foundIndex = this.notificationList.findIndex((element) => element._id === notification._id);
      if (foundIndex != null) {
        this.notificationList[foundIndex].is_seen = true;
        this.notificationCount--;
      }
    }
    const found = notificationRoutes().find((element: any) => element.name == notification.module_name);
    this.uiSpinner.spin$.next(false);
    if (found) {
      if (notification.module_name == 'PO') {
        const routes = notification.module_route;
        routes.document = configData.DOCUMENT_TYPES.po;
        this.router.navigate([found.url], { queryParams: routes }).then();
      } else if (notification.module_name == 'Quote' || notification.module_name == 'Packing Slip' || notification.module_name == 'Receiving Slip') {
        const routes = notification.module_route;
        routes.document = notification.module_name.toString().toUpperCase().replace(/ /g, "_");
        this.router.navigate([found.url], { queryParams: routes }).then();
      } else if (notification.tab_index) {
        if (notification.tab_index != -1) {
          this.router.navigate([found.url], { queryParams: notification.module_route, state: { value: notification.tab_index }, }).then();
        } else {
          this.router.navigate([found.url], { queryParams: notification.module_route }).then();
        }
      } else {
        this.router.navigate([found.url], { queryParams: notification.module_route }).then();
      }
      if (window.location.pathname === found.url) {
        setTimeout(() => {
          location.reload();
        }, 100);
      }
    }
  }

  async getInvoiceMessageCount() {
    const data = await this.commonService.getRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.GET_INVOICE_MESSAGE_COUNT);
    if (data.status) {
      this.unseenCount = data.unseen;
    }
  }

  async markAllRead() {
    const data = await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.UPDATE_ALL_ALERTS, { is_seen: true });
    if (data.status) {
      this.notificationCount = 0;
      for (let i = 0; i < this.notificationList.length; i++) {
        this.notificationList[i].is_seen = true;
      }
    }
  }

  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem(localStorageConstants.DARKMODE)) {
      if (localStorage.getItem(localStorageConstants.DARKMODE) === 'dark') {
        this.isDarTheme = true;
        this.darkIcon = 'moon';
        this.darkThemeBtnClick();
      } else if (localStorage.getItem(localStorageConstants.DARKMODE) === 'light') {
        this.isDarTheme = false;
        this.darkIcon = 'sun';
        this.lightThemeBtnClick();
      } else {
        this.isDarTheme = this.config.layout.variant === 'dark' ? true : false;
        if (this.isDarTheme) {
          this.darkIcon = 'moon';
          this.darkThemeBtnClick();
        } else {
          this.darkIcon = 'sun';
          this.lightThemeBtnClick();
        }
      }
    } else {
      this.isDarTheme = this.config.layout.variant === 'dark' ? true : false;
      if (this.isDarTheme) {
        this.darkIcon = 'moon';
      } else {
        this.darkIcon = 'sun';
      }
    }

    if (localStorage.getItem(localStorageConstants.DARKMODE)) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem(localStorageConstants.DARKMODE) as string
      );
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem('menuOption')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('menuOption') as string
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'menu_' + this.config.layout.sidebar.backgroundColor
      );
    }

    if (localStorage.getItem('choose_logoheader')) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem('choose_logoheader') as string
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        'logo-' + this.config.layout.logo_bg_color
      );
    }

    if (localStorage.getItem('sidebar_status')) {
      if (localStorage.getItem('sidebar_status') === 'close') {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      } else {
        this.renderer.removeClass(this.document.body, 'side-closed');
        this.renderer.removeClass(this.document.body, 'submenu-closed');
      }
    } else {
      if (this.config.layout.sidebar.collapsed === false) {
        this.renderer.addClass(this.document.body, 'side-closed');
        this.renderer.addClass(this.document.body, 'submenu-closed');
      }
    }

    this.toggleControl.valueChanges.subscribe((darkMode) => {
      if (darkMode) {
        // dark mode
        this.darkThemeBtnClick();
      } else {
        // light mode
        this.lightThemeBtnClick();
      }
    });
  }

  modelSwitchChange(event: any) {
    if (event) {
      // dark mode
      this.darkThemeBtnClick();
    } else {
      // light mode
      this.lightThemeBtnClick();
    }
  }

  goChangePassword() {
    this.router.navigate([WEB_ROUTES.CHANGE_PASSWORD]);
  }

  gotoSettings() {
    this.router.navigate([WEB_ROUTES.SIDEMENU_SETTINGS]);
  }

  languageSwitcher() {
    console.log('Language switcher call');
  }

  moveToSettings() {
    this.router.navigate([WEB_ROUTES.SIDEMENU_SETTINGS]).then();
  }

  callFullscreen() {
    if (!this.isFullScreen) {
      this.docElement?.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
    this.isFullScreen = !this.isFullScreen;
  }
  mobileMenuSidebarOpen(event: Event, className: string) {
    const hasClass = (event.target as HTMLInputElement).classList.contains(
      className
    );
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains('side-closed');
    if (hasClass) {
      this.renderer.removeClass(this.document.body, 'side-closed');
      this.renderer.removeClass(this.document.body, 'submenu-closed');
    } else {
      this.renderer.addClass(this.document.body, 'side-closed');
      this.renderer.addClass(this.document.body, 'submenu-closed');
    }
  }
  logout() {
    // this.authService.logout().subscribe((res) => {
    //   if (!res.success) {
    this.authenticationService.changeLoginValue(true);
    this.authenticationService.changeTokenValue('');
    localStorage.removeItem(localStorageConstants.DARKMODE);
    localStorage.removeItem(localStorageConstants.USERDATA);
    localStorage.removeItem(localStorageConstants.COMPANYDATA);
    localStorage.removeItem(localStorageConstants.COMPANYID);
    localStorage.removeItem(localStorageConstants.INVOICE_GIF);
    localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
    localStorage.setItem(localStorageConstants.LOGOUT, 'true');
    localStorage.removeItem('choose_logoheader');
    localStorage.removeItem('choose_skin');
    localStorage.removeItem('menuOption');
    localStorage.removeItem('thinvoicetheme');
    this.router.navigate([WEB_ROUTES.LOGIN]);
    //   }
    // });
  }

  lightThemeBtnClick() {
    this.renderer.removeClass(this.document.body, 'dark');
    this.renderer.removeClass(this.document.body, 'submenu-closed');
    this.renderer.removeClass(this.document.body, 'menu_dark');
    this.renderer.removeClass(this.document.body, 'logo-black');
    if (localStorage.getItem('choose_skin')) {
      this.renderer.removeClass(
        this.document.body,
        localStorage.getItem('choose_skin') as string
      );
    } else {
      this.renderer.removeClass(
        this.document.body,
        'theme-' + this.config.layout.theme_color
      );
    }

    this.renderer.addClass(this.document.body, 'light');
    this.renderer.addClass(this.document.body, 'submenu-closed');
    this.renderer.addClass(this.document.body, 'menu_light');
    this.renderer.addClass(this.document.body, 'logo-white');
    this.renderer.addClass(this.document.body, 'theme-white');
    const theme = 'light';
    const menuOption = 'menu_light';
    // this.selectedBgColor = 'white';
    // this.isDarkSidebar = false;
    localStorage.setItem('choose_logoheader', 'logo-white');
    localStorage.setItem('choose_skin', 'theme-white');
    localStorage.setItem(localStorageConstants.DARKMODE, theme);
    localStorage.setItem('menuOption', menuOption);
  }

  darkThemeBtnClick() {
    this.renderer.removeClass(this.document.body, 'light');
    this.renderer.removeClass(this.document.body, 'submenu-closed');
    this.renderer.removeClass(this.document.body, 'menu_light');
    this.renderer.removeClass(this.document.body, 'logo-white');
    if (localStorage.getItem('choose_skin')) {
      this.renderer.removeClass(
        this.document.body,
        localStorage.getItem('choose_skin') as string
      );
    } else {
      this.renderer.removeClass(
        this.document.body,
        'theme-' + this.config.layout.theme_color
      );
    }
    this.renderer.addClass(this.document.body, 'dark');
    this.renderer.addClass(this.document.body, 'submenu-closed');
    this.renderer.addClass(this.document.body, 'menu_dark');
    this.renderer.addClass(this.document.body, 'logo-black');
    this.renderer.addClass(this.document.body, 'theme-black');
    const theme = 'dark';
    const menuOption = 'menu_dark';
    // this.selectedBgColor = 'black';
    // this.isDarkSidebar = true;
    localStorage.setItem('choose_logoheader', 'logo-black');
    localStorage.setItem('choose_skin', 'theme-black');
    localStorage.setItem(localStorageConstants.DARKMODE, theme);
    localStorage.setItem('menuOption', menuOption);
  }

  switchCompany() {
    if (this.companyList.length > 1) {
      let tempDirection: Direction;

      if (localStorage.getItem('isRtl') === 'true') {
        tempDirection = 'rtl';
      } else {
        tempDirection = 'ltr';
      }
      const dialogRef = this.dialog.open(SwitchCompanyComponent, {
        data: {
          /* advanceTable: this.advanceTable,
          action: 'add', */
        },
        direction: tempDirection,
        panelClass: 'rounded-dialog'
      });
      this.subs.sink = dialogRef.afterClosed().subscribe((result: any) => {
      });
    }
  }
  goUserProfile() {
    this.router.navigate([WEB_ROUTES.USER_FORM], {
      queryParams: { _id: this.user_data.UserData._id },
    });
  }

  viewMessage() {
    this.router.navigate([WEB_ROUTES.INVOICE_MESSAGES]);
  }

  menuClosed() {
    this.openSearchDialog = false;
  }

  onSearchChange(event: any) {
    if (this.openSearchDialog) {
      document.getElementById('global-search')?.click();
    }
    this.openSearchDialog = false;
    if (event.target.value == '') {
      this.invoiceList = [];
      this.invoiceLoader = false;
    } else {
      this.onSearch();
      document.getElementById('global-search')?.click();
      this.openSearchDialog = true;
    }
  }

  async onSearch() {
    if (this.searchControl.value) {
      this.invoiceLoader = true;
      const data = await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.GET_HEADER_INVOICE_SERACH, { search: this.searchControl.value });
      if (data.status) {
        this.invoiceList = data.data;
        this.invoiceLoader = false;
      }
    } else {
      this.invoiceLoader = false;
    }
  }

  openInvoiceDetail(invoice: Invoice) {
    this.searchControl.setValue('');
    this.invoiceLoader = false;
    this.openSearchDialog = false;
    this.router.navigate([WEB_ROUTES.INVOICE_DETAILS], { queryParams: { _id: invoice._id } });
    if (window.location.pathname === WEB_ROUTES.INVOICE_DETAILS) {
      setTimeout(() => {
        location.reload();
      }, 100);
    }
  }

  numberWithCommas(amount: any) {
    return numberWithCommas(amount);
  }

  openDashboard() {
    this.router.navigate([WEB_ROUTES.DASHBOARD]);
  }

  async generateOTP() {
    let that = this;
    that.uiSpinner.spin$.next(true);

    const data = await this.commonService.getRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.PORTAL_GENARATE_SUPERADMIN_OTP);
    if (data.status) {
      showNotification(this.snackBar, data.message, 'success');
      that.uiSpinner.spin$.next(false);
      that.openOTPView(data.data);
    } else {

      showNotification(this.snackBar, data.message, 'error');
      that.uiSpinner.spin$.next(false);
    }

  }
  openOTPView(otp: any) {
    const dialogRef = this.dialog.open(GenerateSuperadminOTP, {
      data: otp,
      disableClose: true,
      panelClass: 'rounded-dialog'
    });
    dialogRef.afterClosed().subscribe((result) => { });
  }

  redirectToPricing() {

  }

  manageSub(): void {
    this.user_data = JSON.parse(localStorage.getItem(localStorageConstants.USERDATA)!);
    if (this.user_data?.companydata) {
      this.is_quickbooks_sync = this.user_data.UserData.is_quickbooks_sync;
      this.companyData = this.user_data.companydata;
      this.isTrialAlertVisible = this.user_data.companydata.is_trial;
    }
    const dialogRef = this.dialog.open(ManageSubscriptionPopUpComponent, {
      height: 'auto',
      width: '50%',
      disableClose: true,
      panelClass: 'rounded-dialog'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate([SUPERADMIN_ROUTES.UPDATE_PAYMENT_RESTRICTION_SCREEN], {
          queryParams: {
            companyId: this.companyData._id,
            companyCode: this.companyData.companycode,
            companyName: this.companyData.companyname,
            companyEmail: this.companyData.companyemail,
            plan: result.name,
            price: result.price,
            is_trial_end: true,
            is_free_trial_upgrade: true,
            plan_id: result._id,
          }
        });
      }
    });
  }

  getFormattedModuleName(moduleKey: string): string {
    return moduleDisplayNames[moduleKey] || moduleKey; // Default to original if not found
  }


  async synchronizeQuickbooks() {
    const qbData = this.companyData['quickbook_online'];
    this.showProgress = true; // Show progress bar
    this.progressValue = 0; // Initialize progress
    this.currentModule = '';

    const reqObject = {
      consumerKey: qbData['client_id'],
      consumerSecret: qbData['client_secret'],
      oauthToken: qbData['access_token'],
      realmId: qbData['realmId'],
      refreshToken: qbData['refresh_token'],
      module: '',
    };
    const moduleList = ['cost_code', 'terms', 'class', 'client', 'vendor', 'invoice'];
    for (let i = 0; i < moduleList.length; i++) {
      reqObject.module = moduleList[i];
      this.currentModule = moduleList[i]; // Update module name for display
      this.progressValue = ((i + 1) / moduleList.length) * 100; // Update progress bar value

      // console.log(reqObject);
      const data = await this.commonService.postRequestAPI(httpVersion.V1 + httpRoutes.QUICKBOOK_SYNC, reqObject);
      if (i == moduleList.length - 1) {
        showNotification(this.snackBar, 'Quickbooks online data sync successfully.', 'success');
      }
    }
    this.showProgress = false;
  }

  async getCompanyTenants() {
    const data = await this.commonService.getRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.GET_COMPANY_SMTP);
    if (data.status) {
      this.onlineLoggedIn = data.data.is_quickbooks_online;
      this.companyData = data.data;
      this.company_name = this.companyData.quickbook_online.company_name;
    }
  }
}

@Component({
  selector: 'app-generate-superadmin-otp',
  templateUrl: './generate-superadmin-otp.html',
  styleUrls: ['./header.component.scss'],
  imports: [MatIconModule, TranslateModule, MatTooltipModule, MatButtonModule]
})

export class GenerateSuperadminOTP extends UnsubscribeOnDestroyAdapter implements OnInit {
  otp: any;
  TitleMessage = this.translate.instant("Your support OTP ");
  image_url: any;



  constructor(
    public httpCall: HttpCall,
    public dialogRef: MatDialogRef<GenerateSuperadminOTP>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService, private commonService: CommonService,
  ) {
    super();
    this.otp = data;
  }

  ngOnInit(): void {
    // Initialization logic if needed
    this.getGIF();
  }

  async getGIF() {
    let that = this;
    const data = await this.commonService.getRequestAPI(httpVersion.SUPERADMIN_V1 + superAdminRoutes.GET_GIF);
    if (data.status) {
      if (data.data != null) {
        that.image_url = data.data.image_url;
        localStorage.setItem("smartaccupay-logo", data.data.image_url);
        localStorage.setItem("smartaccupay-gif", data.data.gif_url);
      }
    }
  }

  closeDialog(): void {
    this.dialogRef.close();

  }

}